import PanelInlineContent from "../../lib/panel/panel-inline-content";
import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import { WrapText } from "lucide-react";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import { EstimatedDeliveryDateBlockProps } from "./types";
import { useTranslation } from "react-i18next";

export default function PanelEstimatedDeliveryDateWrap() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext<EstimatedDeliveryDateBlockProps>();
  const value = blockProps.block.properties?.wrap ? "on" : "off";

  const handleUpdate = (enabled: boolean) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        wrap: enabled,
      },
    });
  };

  return (
    <PanelInlineContent
      title={t(
        "editorBlocksLibrary.blocks.estimated-delivery-date.panel.wrap.title",
        "Two lines",
      )}
    >
      <ToggleGroup
        variant="default"
        type="single"
        className="bg-background border shadow"
        value={value}
        onValueChange={(value) => {
          if (value === "on" || value === "off") {
            handleUpdate(value === "on");
          }
        }}
      >
        <ToggleGroupItem value="on" aria-label="Wrap enabled">
          <WrapText className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="off" aria-label="No wrap">
          <span className="text-xs font-medium">
            {t(
              "editorBlocksLibrary.blocks.estimated-delivery-date.panel.wrap.off",
              "Off",
            )}
          </span>
        </ToggleGroupItem>
      </ToggleGroup>
    </PanelInlineContent>
  );
}
